export const multipoint = {
  data: [
    {
      currentdir: 28.5,
      currentspeed: 0.2,
      humidity: 70,
      pressure: 1005.6,
      swelldir: 238.4,
      swellheight: 0.5,
      swellperiod: 3.3,
      temperature: 21.3,
      time: '2024-06-17 14:00:00',
      visibility: -32767,
      waveheight: 0.5,
      winddir: 245.9,
      windspeed: 6.6,
      x: 121.13555,
      y: 38.727367,
    },
    {
      currentdir: -32767,
      currentspeed: -32767,
      humidity: 64.4,
      pressure: 1006.2,
      swelldir: -32767,
      swellheight: -32767,
      swellperiod: -32767,
      temperature: 21.2,
      time: '2024-06-17 20:00:00',
      visibility: -32767,
      waveheight: -32767,
      winddir: 221.5,
      windspeed: 5,
      x: 122.74172,
      y: 37.48967,
    },
    {
      currentdir: 288.1,
      currentspeed: 0.1,
      humidity: 78.2,
      pressure: 1007.2,
      swelldir: 228.2,
      swellheight: 0.7,
      swellperiod: 3.7,
      temperature: 21.1,
      time: '2024-06-18 02:00:00',
      visibility: -32767,
      waveheight: 0.7,
      winddir: 237,
      windspeed: 7,
      x: 122.71522,
      y: 36.908215,
    },
    {
      currentdir: 287.7,
      currentspeed: 0.2,
      humidity: 80.5,
      pressure: 1007.4,
      swelldir: 228.2,
      swellheight: 0.7,
      swellperiod: 3.7,
      temperature: 21.4,
      time: '2024-06-18 02:00:00',
      visibility: -32767,
      waveheight: 0.7,
      winddir: 232.1,
      windspeed: 7,
      x: 122.5363,
      y: 36.73833,
    },
    {
      currentdir: 253.8,
      currentspeed: 0.1,
      humidity: 85.8,
      pressure: 1008.5,
      swelldir: 179.9,
      swellheight: 0.3,
      swellperiod: 3.2,
      temperature: 20.7,
      time: '2024-06-18 08:00:00',
      visibility: -32767,
      waveheight: 0.3,
      winddir: 207,
      windspeed: 5.2,
      x: 120.66588,
      y: 35.989433,
    },
    {
      currentdir: -32767,
      currentspeed: -32767,
      humidity: 72.9,
      pressure: 1006.4,
      swelldir: -32767,
      swellheight: -32767,
      swellperiod: -32767,
      temperature: 22.6,
      time: '2024-06-18 14:00:00',
      visibility: -32767,
      waveheight: -32767,
      winddir: 161.5,
      windspeed: 5.6,
      x: 120.43828,
      y: 36.00847,
    },
    {
      currentdir: -32767,
      currentspeed: -32767,
      humidity: 72.7,
      pressure: 1006.5,
      swelldir: 164,
      swellheight: 0.3,
      swellperiod: 3,
      temperature: 22.9,
      time: '2024-06-18 14:00:00',
      visibility: -32767,
      waveheight: 0.3,
      winddir: 160.5,
      windspeed: 4.3,
      x: 120.21391,
      y: 35.845047,
    },
    {
      currentdir: -32767,
      currentspeed: -32767,
      humidity: 72.7,
      pressure: 1006.5,
      swelldir: 164,
      swellheight: 0.3,
      swellperiod: 3,
      temperature: 22.9,
      time: '2024-06-18 14:00:00',
      visibility: -32767,
      waveheight: 0.3,
      winddir: 160.5,
      windspeed: 4.3,
      x: 120.1504,
      y: 35.872833,
    },
    {
      currentdir: 188.5,
      currentspeed: 0.1,
      humidity: 77.1,
      pressure: 1006,
      swelldir: 129.4,
      swellheight: 0.3,
      swellperiod: 2.5,
      temperature: 23.8,
      time: '2024-06-18 14:00:00',
      visibility: -32767,
      waveheight: 0.3,
      winddir: 115.1,
      windspeed: 7.1,
      x: 119.8824,
      y: 35.17335,
    },
    {
      currentdir: 180.6,
      currentspeed: 0.2,
      humidity: 66.5,
      pressure: 1005.3,
      swelldir: 129.4,
      swellheight: 0.8,
      swellperiod: 3.6,
      temperature: 30,
      time: '2024-06-18 20:00:00',
      visibility: -32767,
      waveheight: 1,
      winddir: 138.4,
      windspeed: 11,
      x: 119.6904,
      y: 35.084583,
    },
    {
      currentdir: 180.1,
      currentspeed: 0,
      humidity: 59.9,
      pressure: 1005.1,
      swelldir: -32767,
      swellheight: -32767,
      swellperiod: -32767,
      temperature: 23.8,
      time: '2024-06-18 20:00:00',
      visibility: -32767,
      waveheight: -32767,
      winddir: 127.5,
      windspeed: 8.2,
      x: 119.40255,
      y: 35.1601,
    },
  ],
  msg: 'success',
  status: 0,
}
